import React from 'react'
import "./single.css"
import img1 from '../assest/imgs/AI2.jpg';
import user from '../assest/imgs/avat1.png';
import { Link } from 'react-router-dom';
import Menu from '../components/Menu';
import edit from '../assest/imgs/edit1.png';
import deleteIcon from '../assest/imgs/delete.png';

const Single = () => {
  return (
  <div className="single">
    <div className="singleContent">
      <img src={img1} alt=''/>
      <div className="user">
        <img src={user} alt=''/>
        <div className="info">
          <span>John</span>
          <p>Posted 2 days ago</p>
        </div>
        <div className="edit">
          <Link to={`/write?edit=2`}>
            <div className="add">
              <img src={edit} alt=''/>
            </div>
          </Link>
          <div className="delete">
          <img src={deleteIcon} alt=''/>
          </div>
        </div>
      </div>
      <h1>Lorem ipsum dolor, sit amet consectetur adipisicing.</h1>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt perspiciatis ea necessitatibus unde architecto sed molestiae labore voluptatibus cupiditate officia. Ab fugiat quaerat eum! Explicabo aliquid repudiandae dignissimos aliquam numquam.
      <br/><br/>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt perspiciatis ea necessitatibus unde architecto sed molestiae labore voluptatibus cupiditate officia. Ab fugiat quaerat eum! Explicabo aliquid repudiandae dignissimos aliquam numquam.
      <br/><br/>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt perspiciatis ea necessitatibus unde architecto sed molestiae labore voluptatibus cupiditate officia. Ab fugiat quaerat eum! Explicabo aliquid repudiandae dignissimos aliquam numquam. Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt perspiciatis ea necessitatibus unde architecto sed molestiae labore voluptatibus cupiditate officia. Ab fugiat quaerat eum! Explicabo aliquid repudiandae dignissimos aliquam numquam.
       </p>
    </div>
    <div className='menu'>
      <Menu/>
    </div>
  </div>
  )
}

export default Single